import { ServerActionError } from '../types/server-action-error';

export function hasFailed(result: FailableServerAction): result is ServerActionError {
  const isError = (result as ServerActionError)?.error !== undefined;
  return isError;
}

export function hasInternalServerError(result: FailableServerAction): result is ServerActionError {
  return hasFailed(result) && result.statusCode === 500;
}

export function getClientError<T extends Record<string, string>>(
  result: FailableServerAction,
  domainErrors: T,
): string | undefined {
  if (!result || !hasFailed(result) || !result.errorCode) {
    return undefined;
  }
  return domainErrors[result.errorCode];
}

export type FailableServerAction<T = any> = T | ServerActionError;
